import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-cream text-plum" data-id="element-0" data-mp="31bic7tnbuwil">
      <StickyHeader data-id="element-1" data-mp="2wk09b01quluz" />
      <main data-id="element-2" data-mp="2wjgptewg3peu">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-3" data-mp="2wiyy8vkq9zd9" />
        <Hero data-id="element-4" data-mp="2wi5mfg6wwjo9" />
        <SocialProofBar data-id="element-5" data-mp="28u5xmlt5v3cb" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-cream" aria-hidden="true" data-id="element-7" data-mp="28s2ynca15zvg" />} data-id="element-6" data-mp="28sl5f2ubjwhm">
            <DeferredLanding data-id="element-8" data-mp="23utby4e102bb" />
          </Suspense>}
      </main>
    </div>;
}